import { SignedIn, SignedOut, SignOutButton, useAuth } from '@clerk/clerk-react'
import { Link, NavLink } from 'react-router-dom'

import { Logo } from '@/components/brand/Logo'
import { MeStatus } from '@/components/layout/MeStatus'
import { Button } from '@/components/ui/Button'
import { useMe } from '@/context/MeProvider'
import { cn } from '@/lib/cn'
import { LogIn, LogOut } from '@/lib/icons'

const NAV_LINKS = [
  { label: 'Browse', to: '/discover' },
  { label: 'Post', to: '/drop' },
  { label: 'Stash', to: '/stash' },
]

export function SiteHeader() {
  const { isLoaded, isSignedIn } = useAuth()
  const { me } = useMe()
  const homeTo = isLoaded && isSignedIn ? '/discover' : '/'
  const links =
    me?.role === 'admin'
      ? [...NAV_LINKS, { label: 'Admin', to: '/admin' }]
      : NAV_LINKS

  return (
    <header className="border-glass-border bg-surface/80 fixed inset-x-0 top-0 z-50 h-16 border-b backdrop-blur-lg">
      <div className="max-w-site px-margin-mobile md:px-margin-desktop mx-auto flex h-full items-center justify-between gap-4">
        <Link to={homeTo} aria-label="dizcant home" className="rounded-md">
          <Logo />
        </Link>

        <nav aria-label="Primary" className="hidden gap-8 md:flex">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                cn(
                  'font-body text-label-caps rounded-sm uppercase transition-colors',
                  isActive
                    ? 'text-primary'
                    : 'text-on-surface-variant hover:text-primary',
                )
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <SignedOut>
            <Button
              href="/sign-in"
              variant="ghost"
              size="md"
              className="px-3 md:px-5"
            >
              <LogIn className="size-4" aria-hidden="true" />
              Log in
            </Button>
            <Button
              href="/sign-up"
              variant="primary"
              size="md"
              className="px-3 md:px-5"
            >
              Sign up
            </Button>
          </SignedOut>
          <SignedIn>
            <MeStatus />
            <SignOutButton>
              <Button
                variant="secondary"
                size="md"
                className="px-3 md:px-5"
                aria-label="Log out"
              >
                <LogOut className="size-4" aria-hidden="true" />
                <span className="hidden sm:inline">Log out</span>
              </Button>
            </SignOutButton>
          </SignedIn>
        </div>
      </div>
    </header>
  )
}
